<template>
    <div class="container-account" v-loading="loading">
        <h1 class="title">账户总览</h1>
        <!-- 支付服务筛选 -->
        <div class="pay_serve">
            <span class="pay_serve_title">支付服务：</span>
            <el-select
                filterable
                remote
                @focus="handleFocusAppid"
                :remote-method="handleSearchAppid"
                v-model="appid"
                @change="change"
            >
                <el-option
                    v-for="item in appidList"
                    :key="item.appId"
                    :value="item.appId"
                    :label="item.appName"
                >
                </el-option>
            </el-select>
            <el-select
                v-show="flag"
                filterable
                remote
                @focus="handleFocusplitid"
                :remote-method="handleSearchsplitid"
                v-model="splitId"
            >
                <el-option
                    v-for="item in splitList"
                    :key="item.splitId"
                    :value="item.splitId"
                    :label="item.splitName"
                >
                </el-option>
            </el-select>
            <span v-if="!splitId" class="pay_serve_detail">输入appid或服务名称可进行搜索</span>
            <span v-else class="pay_serve_detail">输入splitid或分账对象名称可进行搜索</span>
        </div>
        <!-- 账户状态 -->
        <div class="cards">
            <div>
                <div class="header">
                    <div>
                        账户余额（账户状态：
                        <span :class="capitalInfo.capitalStatus === '封禁' ? 'red' : 'green'">{{ capitalInfo.capitalStatus }}</span>
                        <pop v-if="capitalInfo.blockReason" :content="capitalInfo.blockReason"></pop>
                        )
                    </div>
                    <div
                        v-if="(!crashFlag || capitalFlag) && cashOutFlag"
                        class="freeze"
                        @click="freezeVisible = true"
                    >
                        退款暂封
                        <span>
                            {{ capitalInfo.frozen || "0.00" }}
                        </span>
                        元
                    </div>
                </div>
                <div class="content">
                    <div class="money">
                        <span>
                            {{ capitalInfo.balance || "0.00" }}
                        </span>
                        元
                    </div>
                    <!-- <div v-if="cashOutFlag" class="button">
                        <el-button :type="(crashFlag && !capitalFlag) == true ? 'primary' : 'info'" @click="crashButton">
                            提现
                        </el-button>
                    </div> -->
                    <!-- <div
                        v-else
                        class="freeze"
                        @click="freezeVisible = true"
                    >
                        退款暂封
                        <span>
                            {{ capitalInfo.frozen || "0.00" }}
                        </span>
                        元
                    </div> -->
                </div>
				<div
					class="button-container"
					:class="{ open: openDetail }"
					@click="openDetail = !openDetail"
				>
					账户详情
					<span class="arrow">▼</span>
				</div>
                <!-- <div class="footer clearFix">
                    <div
                        v-if="crashFlag && !capitalFlag"
                        class="freeze"
                        @click="freezeVisible = true"
                    >
                        退款暂封
                        <span>
                            {{ capitalInfo.frozen || "0.00" }}
                        </span>
                        元
                    </div>
                    <template v-else-if="capitalInfo.controlType === 1 && (!crashFlag || capitalFlag)">
                        当前结算周期为{{ capitalInfo.attrValue }}天，下次结算日期预计为{{
                                capitalInfo.paymentDue
                        }}
                    </template>
                    <template v-else>
                        当前结算日期为每月{{
                                capitalInfo.attrValue
                        }}日，下次结算日期预计为{{ capitalInfo.paymentDue }}
                    </template>
                    <pop v-if="!crashFlag || capitalFlag" content="银行大额打款系统休息日不运行，所以当打款金额大于100万时，会顺延到下一个工作日打款，但不影响后续打款周期。"></pop>
                    <div>
                        <span>打款预留{{ capitalInfo.cashPledge || "0.00" }}元</span>
                        <pop content="打款预留金额在商户结算时会被保留在账户余额中。"></pop>
                    </div>
                </div> -->
            </div>
            <div>
                <div class="income">
                    <div class="header">
                        昨日总收入
                        <pop content="昨日所有订单核销减去退款成功的收入金额总和"></pop>
                    </div>
                    <div class="content money">
                        <span>
                            {{ yesterdayInfo.income || "0.00" }}
                        </span>
                        元
                    </div>
                    <div class="footer">
                        <span>{{ yesterdayInfo.incomeCount || 0 }}笔</span>
                    </div>
                </div>
                <div class="income">
                    <div class="header">
                        昨日总支出
                        <pop content="昨日所有商户结算减去结算退票的支出金额总和"></pop>
                    </div>
                    <div class="content money">
                        <span>
                            {{ yesterdayInfo.expense || "0.00" }}
                        </span>
                        元
                    </div>
                    <div class="footer">
                        <span>{{ yesterdayInfo.expenseCount }}笔</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="openDetail" class="balanceList">
            <div
				v-for="(item, index) in capitalInfo.balanceList"
				:key="index"
			>
                <div v-if="item.channelType === 5">
                    <div class="header">
                        <div>
                            百信银行垫资余额（账户状态：
                            <span :class="capitalInfo.capitalStatus === '封禁' ? 'red' : 'green'">{{ capitalInfo.capitalStatus }}</span>
                            <pop v-if="capitalInfo.blockReason" :content="capitalInfo.blockReason"></pop>
                            )
                        </div>
                    </div>
                    <div class="content">
                        <div class="money">
                            <span>
                                {{ item.balance || "0.00" }}
                            </span>
                            元
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="header">
                        <div>
                            {{item.channelType === 1 ? '百信银行聚合余额' : '微信余额'}}（账户状态：
                            <span :class="capitalInfo.capitalStatus === '封禁' ? 'red' : 'green'">{{ capitalInfo.capitalStatus }}</span>
                            <pop v-if="capitalInfo.blockReason" :content="capitalInfo.blockReason"></pop>
                            )
                        </div>
                        <div
                            v-if="(!crashFlag || capitalFlag) && cashOutFlag"
                            class="freeze"
                            @click="freezeVisible = true"
                        >
                            退款暂封
                            <span>
                                {{ capitalInfo.frozen || "0.00" }}
                            </span>
                            元
                        </div>
                    </div>
                    <div class="content">
                        <div class="money">
                            <span>
                                {{ item.balance || "0.00" }}
                            </span>
                            元
                        </div>
                        <div v-if="cashOutFlag" class="button">
                            <el-button :type="(crashFlag && !capitalFlag) == true ? 'primary' : 'info'" @click="crashButton">
                                提现
                            </el-button>
                        </div>
                        <div
                            v-else
                            class="freeze"
                            @click="freezeVisible = true"
                        >
                            退款暂封
                            <span>
                                {{ capitalInfo.frozen || "0.00" }}
                            </span>
                            元
                        </div>
                    </div>
                    <div class="footer clearFix">
                        <div
                            v-if="crashFlag && !capitalFlag"
                            class="freeze"
                            @click="freezeVisible = true"
                        >
                            退款暂封
                            <span>
                                {{ capitalInfo.frozen || "0.00" }}
                            </span>
                            元
                        </div>
                        <template v-else-if="capitalInfo.controlType === 1 && (!crashFlag || capitalFlag)">
                            当前结算周期为{{ capitalInfo.attrValue }}天，下次结算日期预计为{{
                                    item.paymentDue
                            }}
                        </template>
                        <template v-else>
                            当前结算日期为每月{{
                                    capitalInfo.attrValue
                            }}日，下次结算日期预计为{{ capitalInfo.paymentDue }}
                        </template>
                        <pop v-if="!crashFlag || capitalFlag" content="银行大额打款系统休息日不运行，所以当打款金额大于100万时，会顺延到下一个工作日打款，但不影响后续打款周期。"></pop>
                        <div v-if="!(capitalInfo.propertyType === 30 && item.channelType === 2)">
                            <span>打款预留{{ capitalInfo.cashPledge || "0.00" }}元</span>
                            <pop content="打款预留金额在商户结算时会被保留在账户余额中。"></pop>
                        </div>
                        <div v-if="item.channelType !== 1" style="color: red">
                            说明：微信渠道商家技术服务费不参与余额计算，商家技术服务费总计不包含微信渠道技术服务费统计，可在账单管理->交易账单和技术服务费账单中查询技术服务费
                        </div>
                        <!-- 封禁详情 -->
                        <div v-if="capitalInfo && (capitalInfo.stateBlock || capitalInfo.amountBlock)" class="block-detail">
                            <p>状态封禁：{{ capitalInfo.stateBlock }}</p>
                            <p>金额封禁：{{ capitalInfo.amountBlock }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- 资金明细筛选 -->
        <div class="fund_detail">
            <h2>资金明细</h2>
            <div class="select_items">
                <!-- <span class="date_type">日期类型：</span> -->
                <!-- <el-radio-group v-model="tableOptions.timeType">
						<el-radio :label="1">
								发生日期
								<pop content="订单核销、退款或商户结算状态发生变更的时间"></pop>
						</el-radio>
						<el-radio :label="2">
								账务处理日期
								<pop content="订单交易或商户结算传到资金池账务开始处理的时间 "></pop>
						</el-radio>
				</el-radio-group> -->
                <span>结算时间：</span>
                <pop content="订单核销、退款或结算实际的资金出入账时间"></pop>
                <el-date-picker
                    class="date"
                    type="daterange"
                    v-model="tableOptions.time"
                >
                </el-date-picker>
                <span class="fund_type date">资金类型：</span>
                <el-select v-model="tableOptions.moneyType">
                <el-option
                        :value="-1"
                        label="全部"
                    ></el-option>
                    <el-option
                        :value="1"
                        label="订单核销"
                    ></el-option>
                    <el-option
                        :value="21"
                        label="退款封禁"
                    ></el-option>
                    <el-option
                        :value="22"
                        label="退款解封"
                    ></el-option>
                    <el-option
                        :value="2"
                        label="退款成功记账"
                    ></el-option>
                    <el-option
                        :value="3"
                        label="技术服务费"
                    ></el-option>
                    <el-option
                        :value="10"
                        label="商户结算"
                    ></el-option>
                    <el-option
                        :value="11"
                        label="结算退票"
                    ></el-option>
					<el-option
                        :value="40"
                        label="调整款"
                    ></el-option>
					<el-option
                        :value="32"
                        label="退款入账"
                    ></el-option>
					<el-option
                        :value="33"
                        label="垫资充值"
                    ></el-option>
					<el-option
                        :value="34"
                        label="垫资退款-调增"
                    ></el-option>
					<el-option
                        :value="35"
                        label="垫资退款-调减"
                    ></el-option>
					<el-option
                        :value="36"
                        label="垫资提现"
                    ></el-option>
					<el-option
                        :value="37"
                        label="垫资提现退票"
                    ></el-option>
					<el-option
                        :value="38"
                        label="垫资中转"
                    ></el-option>
                </el-select>
				<span class="fund_type date">渠道账户：</span>
                <el-select v-model="tableOptions.channelType">
					<el-option
							:value="0"
						label="全部"
					></el-option>
					<el-option
						:value="1"
						label="百信"
					></el-option>
					<el-option
						:value="2"
						label="微信"
					></el-option>
					<el-option
						:value="5"
						label="百信垫资账户"
					></el-option>
				</el-select>
            </div>

            <div class="button_list">
                <el-button
                    type="primary"
                    @click="searchTableData"
                >查询</el-button>
                <el-button
                    @click="handleRestClick"
                    :style="{ background: '#ecf5ff', 'border-color': '#b3d8ff' }"
                >
                    重置
                </el-button>
                <el-button
                    type="primary"
                    @click="handleDownload"
                >账单下载</el-button>
                <span @click="downloadSaveVisible = true">下载储存区</span>
            </div>
            <div class="all_list">
                <ul>
                    <li style="margin-left: 5px">
                        商家收入总计：<span style="color: green">
                            {{ sumInfo.income || 0.0 }}元</span>
                    </li>
                    <li>
                        商家支出总计：<span style="color: red">{{ sumInfo.expense || 0.0 }}元</span>
                    </li>
                    <li>
                        商家技术服务费总计：<span style="color: red">{{ sumInfo.technology || 0.0 }}元</span>
                    </li>
                    <li>
                        调整款总计：<span style="color: red">{{ sumInfo.adjust || 0.0 }}元</span>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 资金明细表格 -->
        <div class="table_container clearFix">
            <el-table
                :data="tableData"
                style="width: 100%;
                margin-bottom: 10px"
                :default-sort="{ prop: 'accountTime', order: 'ascending' }"
            >
                <el-table-column
                    v-for="item in tableColumn"
                    :key="item.prop"
                    :prop="item.prop"
                    :label="item.label"
                    :sortable="item.sortable"
                >
                    <template slot="header">
                        <span>
                            {{ item.label }}
                            <pop v-if="item.prop === 'orderId'" content="交易类流水此处显示订单号，结算类流水此处显示结算凭证id">
                            </pop>
                            <pop v-if="item.prop === 'operateTime'" content="订单核销、退款或商户结算后实际的资金余额变动时间">
                            </pop>
                            <pop v-if="item.prop === 'settleTargetTime'" content="订单核销、退款或结算实际的资金出入账时间，2024年1月1日起支持按资金入账时间查询账单">
                            </pop>
                        </span>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="item.prop === 'money'" :class="scope.row.money.indexOf('-') > -1 ? 'red' : 'green'">
                            {{ scope.row[item.prop] || '--'  }}
                        </span>
                        <span v-else-if="item.prop === 'settleTargetTime'">
                            {{ (scope.row[item.prop] === '' || scope.row[item.prop] === undefined) ? "--" : scope.row[item.prop] }}
                        </span>
                        <span v-else-if="item.prop === 'accountFlag'">
                            {{ scope.row[item.prop] === 1 ? "已入账" : "未入账" }}
                        </span>
                        <span v-else-if="item.prop === 'orderId'">
                            {{ scope.row.orderId || scope.row.taskId || '--' }}
                        </span>
                        <span v-else-if="item.prop === 'operate'">
                            <a
                                v-if="scope.row.bankReceipt"
                                :href="scope.row.bankReceipt"
                                class="operate"
                            >
                             回单下载
                            </a>
                        </span>
                        <div v-else-if="item.prop === 'optType'">
                            {{ scope.row[item.prop] || '--' }}
                            <pop v-if="scope.row.rebackReason" :content="scope.row.rebackReason"></pop>
                        </div>
                        <span v-else>
                            {{ scope.row[item.prop] || '--'}}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <img
                    src="../../img/bulb.png"
                    alt=""
                    class="bulb"
                />
                <span>账户的资金为收支分离的模式，支出金额与收入金额并无直接关联也无法直接匹配，且因百度与银行间系统数据传输可能产生的跨账期时延，导致在结算后的账户余额有剩余，对账时请关注结算后的账户余额，如需核对明细请到“账单管理”中下载资金、交易、技术服务费或结算账单。</span>
            </div>
            <div class="pag_container">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="tableOptions.totalCount"
                    @current-change="tablePageChange"
                    :page-size="10"
                >
                </el-pagination>
            </div>
        </div>
        <!-- 冻结资金明细弹窗 -->
        <el-dialog
            title="退款暂封金额"
            width="70%"
            :visible.sync="freezeVisible"
        >
            <freezeTable
                v-if="freezeVisible"
                :appId="appid"
                :close="closeFreezeDialog"
            ></freezeTable>
        </el-dialog>
        <!-- 下载储存区提示 -->
        <div class="notify_container">
            <el-dialog
                width="50%"
                :visible.sync="notifyVisible"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :show-close="false"
            >
                <div class="notify">
                    <span>账单已开始下载，请在下载存储区中查看</span>
                </div>
            </el-dialog>
        </div>
        <!-- 下载储存区弹框 -->
        <el-dialog
            title="下载储存区"
            width="50%"
            :visible.sync="downloadSaveVisible"
        >
            <downloadSave
                :appId="appid"
                :splitId="splitId"
                v-if="downloadSaveVisible"
            ></downloadSave>
        </el-dialog>
        <!-- 提现弹出框 -->
        <el-dialog
            title="发起提现(每日限一次)"
            width="25%"
            :visible.sync="crashVisible"
            class="crashDialog"
            @close="crashDataClose"
        >
            <div class="pay_serve">
                <span class="pay_serve_title">提现金额：</span>
                <el-input
                    id="crashInput"
                    @input="crashDataChange"
                    v-model="inputCrashData"
                    placeholder="请输入提现金额"
                >
                </el-input>
                <span class="pay_serve_detail">元</span>
            </div>
            <span v-if="overCrashData" class="pay_serve_detail red overcrash">提现金额超过了可提余额</span>
            <span v-if="negativeFlag" class="pay_serve_detail red overcrash">请输入正确提现余额</span>
            <div class="balance">
                <span class="freeze">当前可提现余额{{ canCrashData || "0.00" }}元</span>
                <pop content="可提现余额=账户余额-打款预留金额"></pop>
            </div>
            <div class="dialog-footer">
                <el-button type="primary" @click="crashConfirm">确 定</el-button>
                <el-button @click="crashVisible = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {
    requestDetailData,
    requestBalanceData,
    requestAppidList,
    detailExport,
    getSplitList,
    crashData,
} from "../../api/apiMap/index.js";
import { getLastWeek } from "../../utils/utils";
import pop from "../../components/pop";
import freezeTable from "./freezeTable.vue";
import downloadSave from "../../components/downloadSave";
export default {
    components: {
        pop,
        downloadSave,
        freezeTable,
    },
    data() {
        return {
            canCrashData: "" , // 可提现余额
            inputCrashData: "", // 提现金额
            overCrashData: false, // 提现金额是否超过可提现余额
            crashFlag: false, // 根据提现次数， 账户状态判断是否可提现
            capitalFlag: false, // 账户状态是否封禁
            cashOutFlag: false, // 是否有资格提现
            negativeFlag: false, // 输入金额是否为负数
            flag: false, //判断是否显示分账
            cheackedvalue: "",//判断如果分账保留一份分类id
            loading: false, // 加载状态
			openDetail: false, // 账户详情
            splitList: [
                // {
                //     split_name: "11",
                //     splitName: "11",
                //     serviceType: 3,
                //     service_type: 3,
                //     split_id: 12,
                //     splitId: 12,
                // },
                // {
                //     split_name: "33",
                //     splitName: "33",
                //     serviceType: 1,
                //     service_type: 1,
                //     split_id: 123,
                //     splitId: 123,
                // },
                // {
                //     split_name: "77",
                //     splitName: "77",
                //     serviceType: 1,
                //     service_type: 1,
                //     split_id: 1234,
                //     splitId: 1234,
                // },
            ], //分账列表
            appidList: [
                // {
                //     app_name: "1",
                //     appName: "1",
                //     serviceType: 1,
                //     service_type: 1,
                //     appId: 10863,
                //     app_id: 10863,
                // },
                // {
                //     app_name: "2",
                //     appName: "2",
                //     serviceType: 3,
                //     service_type: 3,
                //     appId: 10862,
                //     app_id: 10862,
                // },
                // {
                //     app_name: "3",
                //     appName: "3",
                //     serviceType: 1,
                //     service_type: 1,
                //     appId: 10861,
                //     app_id: 10861,
                // },

                //         {
                //             app_name: "1",
                //             appName: "1",
                //             serviceType: 1,
                //             service_type: 1,
                //             appId: 10863,
                //             app_id: 10863,
                //         },
                //         {
                //             app_name: "2",
                //             appName: "2",
                //             serviceType: 3,
                //             service_type: 3,
                //             appId: 10862,
                //             app_id: 10862,
                //         },
                //         {
                //             app_name: "3",
                //             appName: "3",
                //             serviceType: 1,
                //             service_type: 1,
                //             appId: 10861,
                //             app_id: 10861,
                //         },
            ], // 下拉列表
            appName: "", // 输入筛选
            appid: "", // appid
            splitId: "", // 分账id
            capitalInfo: {
                balance: "", // 余额（元）
                frozen: "", // 冻结金额（元）
                cashPledge: "", // 打款预留（元）
                controlType: 1, // 打款类型
                attrValue: 0, // 打款类型值
                paymentDue: "", // 下次打款时间
				balanceList: [],
            },
            yesterdayInfo: {
                income: "", // 收入（元）
                incomeCount: "", // 收入流水数量
                expense: 0, // 支出（元）
                expenseCount: 0, // 支出流水数量
            },
            sumInfo: {
                expense: "",
                expenseCount: 0,
                income: "",
                incomeCount: 0,
                technology: "",
                technologyCount: 0,
            },
            tableColumn: [
                // {
                //     prop: "settleTargetTime",
                //     label: "资金入账时间",
                // },
                {
                    prop: "operateTime",
                    label: "结算时间",
                    sortable: false,
                },
                {
                    prop: "orderId",
                    label: "订单号、结算凭证",
                },
                {
                    prop: "refMoney",
                    label: "订单/结算金额（元）",
                },
                {
                    prop: "optType",
                    label: "资金类型",
                },
                {
                    prop: "channelDesc",
                    label: "渠道账户",
                },
                {
                    prop: "money",
                    label: "交易金额(元)",
                },
                // {
                //     prop: "accountFlag",
                //     label: "入账状态",
                // },
                {
                    prop: "accountAfterMoney",
                    label: "账户余额（元）",
                },
                {
                    prop: 'operate',
                    label: '操作'
                }
            ], // 主表格数据表头
            crashVisible: false, //提现弹框是否
            tableData: [], // 主表格数据
            freezeVisible: false, // 冻结明细弹窗是否显示
            notifyVisible: false, // 账单开始下载提示
            downloadSaveVisible: false, // 下载储存区是否显示
            downloadSaveTableData: [], // 下载储存区表格数据
            tableOptions: {
                // 主表格筛选参数
                timeType: 1, // 筛选时间名称
                moneyType: -1, // 资金类型
                time: getLastWeek(), // 日期筛选框
                curPage: 1, // 页码
                pageSize: 10,
                totalCount: 0, // 总条数
				channelType: 0,
            },
            searchTableItems: {
                type: this.splitId == "" ? 0 : 2,
                // 用于缓存发送请求时的筛选条件,这里是实际用于发请求的数据
                appId: this.splitId == "" ? this.appid : this.splitId, // 服务ID
                timeType: 1, // 筛选时间名称
                moneyType: -1, // 资金类型

                startTime: "", // 开始时间
                endTime: "", // 结束时间
                curPage: 1,
                pageSize: 10,
            },
            // 金额封禁
            amountBlock: '',
            // 状态封禁
            stateBlock: '',
        };
    },
    created() {
        this.getAppidList("", true);
    },
    watch: {
        // 当appid发生改变,应该重新获取数据,因为balabceData和tableData的获取都依赖于appid
        appid(value) {
            this.searchTableItems.appId = value;
            if (this.flag !== true) {
                this.getBalanceData(value);
                this.initGetTableData();
            }
        },
        splitId(value) {
            this.searchTableItems.appId = value;
            this.getBalanceData(value);
            this.initGetTableData();
        },
    },
    methods: {
        //提现按钮事件
        crashButton() {
            if (!this.crashFlag) {
                this.$message({
                    message: '今日提现次数已超限！',
                    type: 'erroe',
                    duration: 2000
                });
                return;
            }
            if (this.capitalFlag) {
                return;
            }
            this.canCrashData = ((this.capitalInfo.balance.replace(/,/g, '') * 100) - (this.capitalInfo.cashPledge.replace(/,/g, '') * 100)) / 100
            this.crashVisible = true;
        },
        // 提现函数
        crashConfirm() {
            if (this.overCrashData || this.negativeFlag) {
                return;
            }
            this.crashVisible = false;
            let applyMoney = this.inputCrashData;
            crashData({
                type: this.splitId == "" ? 0 : 2,
                appId: this.splitId == "" ? this.appid : this.splitId,
                applyMoney: applyMoney,
            })
                .then(res => {
                    if (res.errno === 0) {
                        this.$message({
                            message: '提现发起成功',
                            type: 'success',
                            duration: 2000
                        });
                        this.getBalanceData(this.appid);
                    } else {
                        this.$message.error("提现失败");
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误");
                })
        },
        crashDataClose() {
            this.inputCrashData = '';
            this.overCrashData = false;
            this.negativeFlag = false;
        },
        // 输入提现金额触发函数
        crashDataChange() {
            // 如果使用正则就不要使用type = ‘number’，正则会被覆盖
            //保证只能输入数字
            this.inputCrashData = this.inputCrashData.replace(/^(-)(\d+).(\d\d).$/, '$1$2.$3').replace(/[^\d.]/g, '');
            // 保证小数点只有一位
            this.inputCrashData = this.inputCrashData.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
            //保证第一位是数字不是小数点
            this.inputCrashData = this.inputCrashData.replace(/^\./g, '');
            this.negativeFlag = (this.inputCrashData == false) ? true : false;
            if (('' + this.inputCrashData).split('.')[1]) {
                this.negativeFlag = ('' + this.inputCrashData).split('.')[1].length > 2 ? true : false;
            }
            let crashData = parseFloat(this.inputCrashData).toFixed(2);
            if (this.capitalInfo.cashPledge) {
                crashData = ((this.capitalInfo.cashPledge.replace(/,/g, '') * 100) + (crashData * 100)) / 100;
            }
            this.overCrashData = (Number(this.capitalInfo.balance.replace(/,/g, '')) < crashData) ? true : false;
        },
        // 重置筛选条件
        resetTableOptions() {
            // 重置筛选条件
            this.tableOptions = {
                timeType: 1,
                moneyType: -1,
                time: getLastWeek(),
                curPage: 1,
                pageSize: 10,
                totalCount: 0,
				channelType: 0,
            };
        },
        // 第一次获取主表格数据和修改appId的时候调用
        initGetTableData() {
            // 重置筛选条件为默认值
            this.resetTableOptions();
            // 缓存筛选条件
            this.searchTableItems = {
                type: this.splitId == "" ? 0 : 2,
                appId: this.splitId == "" ? this.appid : this.splitId,
                timeType: 1,
                moneyType: -1,
				channelType: 0,
                startTime: new Date(this.tableOptions.time[0]).getTime() + "",
                endTime: new Date(this.tableOptions.time[1]).getTime() + "",
                curPage: 1,
                pageSize: 10,
            };
            this.getTableData(this.searchTableItems);
        },
        // 主表格分页器
        tablePageChange(page) {
            this.tableOptions.curPage = page;
            this.searchTableItems.curPage = page;
            this.getTableData(this.searchTableItems);
        },
        // 获取焦点首先重新拉取一下
        handleFocusAppid() {
            this.getAppidList("", false);
        },
        // 输入appid进行搜索
        handleSearchAppid(appName) {
            this.getAppidList(appName, false);
        },
        handleFocusplitid() {
            this.usergetSplitList("");
        },
        // 输入splitid进行搜索
        handleSearchsplitid(splitName) {
            this.usergetSplitList(splitName);
        },
        // 获取balanceData
        getBalanceData(appid) {
            if (!appid) {
                return;
            }
            this.loading = true;
            requestBalanceData({
                type: this.splitId == "" ? 0 : 2,
                appId: this.splitId == "" ? appid : this.splitId,
                timestamp: new Date().getTime() + "",
            })
                .then((result) => {
                    if (result.errno === 0) {
                        this.capitalInfo = result.data ? result.data.capitalInfo : {};
                        if (this.capitalInfo.cashOutType == 4) {
                            this.cashOutFlag = true;
                            this.crashFlag = this.capitalInfo.canWithdraw;
                            this.capitalFlag = (this.capitalInfo.capitalStatus == '封禁') ? true : false;
                        }
                        this.yesterdayInfo = result.data ? result.data.yesterdayInfo : {};
                        this.loading = false;
                    } else {
                        this.$message.error(result.errmsg || result.msg || "");
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误");
                    this.loading = false;
                });
        },
        // 发送请求获取主表格数据
        getTableData(params) {
            this.loading = true;
            requestDetailData(params)
                .then((result) => {
                    if (result.errno === 0) {
                        this.sumInfo = result.data.sumInfo;
                        this.tableData = result.data ? result.data.data : [];
                        this.tableOptions.totalCount = result.data
                            ? result.data.totalCount
                            : 0;
                        this.loading = false;
                    } else {
                        this.$message.error(result.errmsg || result.msg || "");
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误");
                    this.loading = false;
                });
        },
        // 获取appidlist, 第二个参数为标记第一次进入页面的时候，默认选中第一个appid
        getAppidList(appName = "", setAppid = false) {
            this.loading = true;
            requestAppidList(appName)
                .then((result) => {
                    if (result.errno === 0) {
                        this.appidList = result.data;
                        if (setAppid) {
                            this.appid =
                                result.data && result.data[0] ? result.data[0].appId : "";
                        }
                        this.loading = false;
                    } else {
                        this.$message.error(result.errmsg || result.msg || "");
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误");
                    this.loading = false;
                });
        },
        // 点击查询按钮
        searchTableData() {
            if (
                !this.appid ||
                !this.tableOptions.timeType ||
                !this.tableOptions.time ||
                this.tableOptions.time.length < 0
            ) {
                this.$message.error("所选查询参数错误");
                return;
            }
            this.tableOptions.curPage = 1;
            this.tableOptions.totalCount = 0;
            this.searchTableItems = {
                type: this.splitId == "" ? 0 : 2,
                appId: this.splitId == "" ? this.appid : this.splitId,
                timeType: this.tableOptions.timeType,
                moneyType: this.tableOptions.moneyType,
				channelType: this.tableOptions.channelType,
                startTime: new Date(this.tableOptions.time[0]).getTime() + "",
                endTime: new Date(this.tableOptions.time[1]).getTime() + "",
                curPage: 1,
                pageSize: 10,
            };
            this.getTableData(this.searchTableItems);
        },
        // 点击重置按钮(只重置筛选条件,不发请求,不修改页码和总条数)
        handleRestClick() {
            this.tableOptions.timeType = 1;
            this.tableOptions.moneyType = -1;
			this.tableOptions.channelType = 0;
            this.tableOptions.time = getLastWeek();
        },
        // 点击账单下载(使用当前筛选的对象里的参数)
        handleDownload() {
            if (
                !this.appid ||
                !this.tableOptions.timeType ||
                !this.tableOptions.time ||
                this.tableOptions.time.length < 0
            ) {
                this.$message.error("所选参数错误");
                return;
            }
            this.loading = true;
            detailExport({
                type: this.splitId == "" ? 0 : 2,
                appId: this.splitId == "" ? this.appid : this.splitId,
                timeType: this.tableOptions.timeType,
                moneyType: this.tableOptions.moneyType,
				channelType: this.tableOptions.channelType,
                startTime: new Date(this.tableOptions.time[0]).getTime() + "",
                endTime: new Date(this.tableOptions.time[1]).getTime() + "",
            })
                .then((result) => {
                    if (result.errno === 0) {
                        this.openNotify();
                        this.loading = false;
                    } else {
                        this.$message.error(result.errmsg || result.msg || "");
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误");
                    this.loading = false;
                });
        },
        // 打开账单下载的提示框,2秒后关闭
        openNotify() {
            if (!this.notifyVisible) {
                this.notifyVisible = true;
            }
            setTimeout(() => {
                this.notifyVisible = false;
            }, 2000);
        },
        // 关闭冻结金额明细
        closeFreezeDialog() {
            this.freezeVisible = false;
        },
        change(value) {
            this.splitId = "";
            this.flag = false;
            this.appidList.forEach((item) => {
                if (item.appId == value && item.serviceType == 3) {
                    this.flag = true;
                    this.cheackedvalue = value
                    getSplitList({ appId: value }).then((result) => {
                        if (result.errno === 0) {
                            this.splitList = result.data;
                            this.splitId = this.splitList[0].splitId;
                        } else {
                            this.$message.error(result.errmsg || result.msg || "");
                        }
                    });
                }
            });
        },
        //二级导航输入搜索调用
        usergetSplitList(splitInfo) {
            getSplitList({ appId: this.cheackedvalue, splitInfo }).then(
                        (result) => {
                            if (result.errno === 0) {
                                this.splitList = result.data;
                                this.splitId = this.splitList[0].splitId;
                            } else {
                                this.$message.error(result.errmsg || result.msg || "");
                            }
                        }
                    );
        },
    },
};
</script>
<style lang="less" scope>
.container-account {
	.button-container {
		cursor: pointer; /* 指示这是一个可以点击的元素 */
		user-select: none; /* 防止文本被选择 */
	}

	.arrow {
		display: inline-block;
		margin-left: 5px;
		color: #1d98ff;
		transition: transform 0.3s ease; /* 平滑过渡效果 */
	}

	.button-container.open .arrow {
		transform: rotate(180deg); /* 当按钮处于打开状态时旋转箭头 */
	}
    .title {
        font-size: 18px;
        margin-bottom: 15px;
    }

    .pay_serve {
        margin-bottom: 20px;

        .el-input {
            transform: scale(99%);
        }
    }
	.balanceList{
		.balance-item{

		}
	}
	.balanceList{
        display: flex;
        margin-bottom: 20px;
        color: #3b3b3bc9;

        &>div {
            border-radius: 10px;
            width: 425px;
            margin-right: 20px;
            box-sizing: border-box;
            border: 1px solid #dcdfe6;
            padding: 15px 20px;

			.header {
				margin-bottom: 10px;
				font-size: 14px;
				display: flex;
				justify-content: space-between;
				flex-direction: row;

				.freeze {
					color: #1d98ff;
					cursor: pointer;
				}
			}

			.content {
				display: flex;
				justify-content: space-between;
				align-items: flex-end;
				padding-right: 25px;
				margin-bottom: 10px;

				.money {
					font-size: 20px;
				}

				.button {

					.el-button {
						transform: scale(80%);
					}

					&>span {
						color: #1d98ff;
						cursor: pointer;
					}
				}

				.freeze {
					color: #1d98ff;
					cursor: pointer;
				}
			}

			.footer {
				font-size: 12px;

				.freeze {
					color: #1d98ff;
					cursor: pointer;
				}

				&>div {
					margin-top: 10px;
				}

                .block-detail {
                    font-size: 18px;
                    p:last-child {
                        margin-top: 10px;
                    }
                }

			}
			.income {
				width: 50%;
				box-sizing: border-box;

				.header {
					font-size: 14px;
					margin-bottom: 20px;
				}

				.content {
					margin-bottom: 20px;
				}

				.footer {
					font-size: 12px;
					margin-top: 10px;

					span {
						margin-right: 10px;
					}
				}
            }
        }
    }
    .cards {
        display: flex;
        margin-bottom: 20px;
        color: #3b3b3bc9;

        &>div {
            border-radius: 10px;
            width: 425px;
            margin-right: 20px;
            box-sizing: border-box;
            border: 1px solid #dcdfe6;
            padding: 15px 20px;

            &:first-child {
                .header {
                    margin-bottom: 10px;
                    font-size: 14px;
                    display: flex;
                    justify-content: space-between;
                    flex-direction: row;

                    .freeze {
                        color: #1d98ff;
                        cursor: pointer;
                    }
                }

                .content {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-end;
                    padding-right: 25px;
                    margin-bottom: 10px;

                    .money {
                        font-size: 20px;
                    }

                    .button {

                        .el-button {
                            transform: scale(80%);
                        }

                        &>span {
                            color: #1d98ff;
                            cursor: pointer;
                        }
                    }

                    .freeze {
                        color: #1d98ff;
                        cursor: pointer;
                    }
                }

                .footer {
                    font-size: 12px;

                    .freeze {
                        color: #1d98ff;
                        cursor: pointer;
                    }

                    &>div {
                        margin-top: 10px;
                    }
                }
            }

            &:last-child {
                display: flex;
                justify-content: space-between;

                .income {
                    width: 50%;
                    box-sizing: border-box;

                    .header {
                        font-size: 14px;
                        margin-bottom: 20px;
                    }

                    .content {
                        margin-bottom: 20px;
                    }

                    .footer {
                        font-size: 12px;
                        margin-top: 10px;

                        span {
                            margin-right: 10px;
                        }
                    }
                }
            }
        }
    }

    .fund_detail {

        // margin-bottom: 20px;
        h2 {
            font-size: 18px;
            margin-bottom: 15px;
        }

        .select_items {
            margin-bottom: 10px;

            .date {
                margin-left: 20px;
            }

            .el-date-editor--daterange,
            .el-input {
                transform: scale(80%);
                transform-origin: 0;
            }
        }

        .button_list {
            .el-button {
                transform: scale(80%);
                margin-right: 15px;
                margin-left: 0;
            }

            &>span {
                color: #1d98ff;
                cursor: pointer;
            }
        }

        .all_list {
            font-size: 16px;
            margin-top: 10px;
            border: 1px #e9e9e9 solid;
            border-radius: 5px;
            padding: 5px;

            ul {
                width: 60%;
                height: 100%;
                line-height: 30px;
                list-style: none;
                display: flex;
                justify-content: space-between;
            }
        }
    }

    .freeze_dialog_footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;

        .el-button {
            transform: scale(80%);
            margin-right: 10px;
        }
    }

    .notify_container {
        .el-dialog__header {
            padding: 0;
        }

        .notify {
            width: 100%;
            height: 100%;
            position: relative;

            &>span {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                font-size: 16px;
            }
        }
    }

    .pag_container {
        float: right;
        margin-right: 20px;
    }

    .money {
        font-size: 12px;

        span {
            font-size: 20px;
            font-weight: bold;
        }
    }

    .clearFix {

        &::before,
        &::after {
            content: "";
            display: block;
            clear: both;
        }

        .bulb {
            width: 20px;
            height: 20px;
            vertical-align: top;
        }
    }

    .crashDialog {

        .pay_serve {
            display: flex;
            justify-content: space-around;
            align-items: center;
            padding-left: 5px;
            margin-bottom: 1px;

            .el-input {
                flex: 1;
                transform: scale(99%);
                margin-right: 10px;
            }
        }

        .overcrash {
            padding-left: 75px;
        }

        .balance {
            padding-left: 5px;
            margin: 30px 0;

            .freeze {
                color: #1d98ff;
                cursor: pointer;
                margin-right: 3px;
            }
        }

        .dialog-footer {
            margin-top: 0;
            display: flex;
            justify-content: flex-end;
        }
    }

    .red {
        color: #f56c6c;
    }

    .green {
        color: #68c33a;
    }
    .operate{
        color: #1d98ff;
        cursor: pointer;
    }
}
</style>
